
    import {
        computed,
        defineComponent,
        unref,
    } from 'vue';
    import { useState } from 'vuex-composition-helpers';
    import Dropdown from '@ve/components/dropdown/desktop/Dropdown.vue';
    import CheckBoxInputList from '@fr/vue/components/inputs/CheckBoxInputList.vue';
    import CheckBoxInput from '@ve/components/inputs/CheckBoxInput.vue';
    import { MapForFiltersState } from '@ve/components/hotel/filters/common/store/types';
    import HintTooltip from '@ve/components/hintTooltip/desktop/HintTooltip.vue';
    import TextCommon from '@ve/components/inputs/TextCommon.vue';
    import useMealsFilterHotel from './use/useMealsFilterHotel';

    const filtersMappingStoreName = 'mapForFilters';

    export default defineComponent({
        name: 'meals-filter-hotel',
        components: {
            TextCommon,
            HintTooltip,
            Dropdown,
            CheckBoxInputList,
            CheckBoxInput,
        },
        setup(props, { emit }) {
            const {
                meals,
                mealsRepository,
                products,
            } = useState<MapForFiltersState>(filtersMappingStoreName, ['meals', 'mealsRepository', 'products']);

            const selectedMeals = computed({
                get: () => unref(meals),
                set: (value) => {
                    emit('meals-filter-changed', value);
                },
            });

            return {
                selectedMeals,
                ...useMealsFilterHotel({ selectedMeals, mealsRepository, products }),
            };
        },
    });
